import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Link from 'components/common/Link';
import TextField from 'components/fields/TextField';
import CheckboxField from 'components/fields/CheckboxField';
import FormError from 'components/common/FormError';

import { accountLogin } from 'redux/modules/account';

import * as validate from 'utils/validate';

const styles = theme => ({
  grid: {
    marginTop: 15,
    '&:first-child': {
      marginTop: 0,
    },
  },
  typography: {
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 14,
    marginBottom: 24,
    marginTop: 24,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function onSubmit(values, dispatch) {
  const normalizedValues = Object.assign({}, values);
  delete normalizedValues['Remember me'];
  return new Promise((resolve, reject) => {
    dispatch(accountLogin({
      values: normalizedValues,
      resolve,
      reject,
    }));
  }).then(res => ({
      ...res,
      email: normalizedValues.Email,
    }),
    (err) => {
      throw new SubmissionError({
        _error: err.error,
      });
    });
}

const LoginForm = ({ className, handleSubmit, error, classes }) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Typography
      className={classes.typography}
      color="secondary"
    >
      Welcome back!
    </Typography>
    {error &&
      <Grid
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Email"
          name="Email"
          label="Email"
          placeholder="Enter Email"
          component={TextField}
          validate={[validate.required, validate.email]}
          size="lg"
          type="email"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Password"
          name="Password"
          label="Password"
          placeholder="Enter Password"
          component={TextField}
          validate={[validate.required]}
          size="lg"
          type="password"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      container
      alignItems="center"
      justify="space-between"
      spacing={24}
    >
      <Grid item>
        <Field
          id="Remember me"
          name="Remember me"
          label="Remember me"
          component={CheckboxField}
        />
      </Grid>
      <Grid item>
        <Link
          size="md"
          href="/account/reset-password"
          underline
        >
          Forgot your password?
        </Link>
      </Grid>
    </Grid>
  </form>
);

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

LoginForm.defaultProps = {
  error: null,
  className: '',
};

export default reduxForm({
  onSubmit,
})(withStyles(styles)(LoginForm));



// WEBPACK FOOTER //
// ./src/components/account/Login/LoginForm.js